import React, { useEffect, useRef, useState } from "react";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
} from "../../components/Component";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import * as moment from "moment";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from "react-router-dom";
import Table from "../../components/react-table/Table";
import { useUser } from "../../context/user";
import { GET } from "../../helper/api";
import { isPN } from "../../utils/feature-flag-key";
const { colTableCn, colTableNvvp, colTableDriver } = require(`../employeemanager/components/SalaryPerMonthColTable`);

const colTableCostAdvance = [
  {
    Header: "Đầu kỳ(đ)",
    className: 'text-right',
    accessor: (item) => (
      <NumericFormat
        displayType={"text"}
        value={item.firstDebt || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={0}
      />
    ),
  },
  {
    Header: "Chi phí cá nhân(đ)",
    className: 'text-right',
    accessor: (item) => (
      <NumericFormat
        displayType={"text"}
        value={item.personalCost || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={0}
      />
    ),
  },
  {
    Header: "Ứng trước(đ)",
    className: 'text-right',
    accessor: (item) => (
      <NumericFormat
        displayType={"text"}
        value={(item.advanceSalary || 0) * -1}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={0}
      />
    ),
  },
  {
    Header: "Cuối kỳ(đ)",
    className: 'text-right font-weight-bold',
    accessor: (item) => (
      <NumericFormat
        displayType={"text"}
        value={item.lastDebt || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={0}
      />
    ),
  },
];

const MySalaryPerMonth = () => {
  const printRef = useRef();
  const {
    state: { user },
  } = useUser();
  const [data, setData] = useState();
  const [costAdvanceData, setCostAdvanceData] = useState();
  const location = useLocation();
  const history = useHistory();

  const searchParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(false);
  const [smOption, setSmOption] = useState(false);
  const [filter, setFilter] = useState({
    monthYear: searchParams.get("monthYear") || moment().format("YYYY-MM"),
  });


  useEffect(() => {
    const newParams = new URLSearchParams({
      monthYear: filter.monthYear,
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    });

    const { monthYear } = filter;
    GET(
      "/self-employee/salary-per-month",
      {
        monthYear,
      },
      true
    ).then((resp) => {
      const {
        data,
      } = resp;
      setData(data || null);
    });

    if (isPN && user.unit === 'DRIVER') {
      GET(
        "/self-employee/driver-cost-advance-per-month",
        {
          monthYear,
        },
        true
      ).then((resp) => {
        const { data } = resp;
        setCostAdvanceData(data || null);
      });
    }
  }, [filter]);

  let colTable = [

  ];

  if ([
    'STAFF_SYSTEM',
    'DIRECTOR',
    'CHIEF_ACCOUNTANT',
    'LABOR',
    'NVVP',
  ].includes(user.unit)) {
    colTable = colTableNvvp({
      onDoubleClickPit: (item) => { }
    })
  } else if (['DRIVER'].includes(user.unit)) {
    colTable = colTableDriver
  } else {
    colTable = colTableCn({
      onDoubleClickPit: (item) => { }
    })
  }

  return (
    <React.Fragment>
      <Head title="Lương tháng của tôi"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Lương tháng của tôi</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <input
                          type="month"
                          className="form-control  border-primary"
                          value={filter.monthYear}
                          onChange={(e) =>
                            setFilter({
                              ...filter,
                              monthYear: e.target.value,
                            })
                          }
                        />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3" ref={printRef}>
                  <h5 className="text-center mt-2 mb-2">
                    Bảng lương {filter?.monthYear} của tôi
                  </h5>
                  {data === null ? <h5 className="w-100 text-center">Chưa chốt chấm công tháng này</h5> : <></>}
                  {!!data ? <Table
                    loading={loading}
                    columns={colTable}
                    data={[data]}
                    notShowPagi
                  ></Table> : <></>}


                </div>
              </div>
            </div>
          </div>
        </Block>

        {isPN && user.unit === 'DRIVER' && !!costAdvanceData ? (
          <Block>
            <div className="card card-bordered card-preview">
              <div className="card-inner">
                <div className="my-3">
                  <h5 className="text-center mt-2 mb-2">
                    Chi phí và ứng trước tháng {filter?.monthYear} của tôi
                  </h5>
                  <Table
                    loading={loading}
                    columns={colTableCostAdvance}
                    data={[costAdvanceData]}
                    notShowPagi
                  ></Table>
                </div>
              </div>
            </div>
          </Block>
        ) : <></>}
      </Content>
    </React.Fragment>
  );
};

export default MySalaryPerMonth;
